// The deployment environment from the backend: GET /v2/agent-call-connect returns
// node_env (the API server's NODE_ENV). Same source the softphone and
// getTtsConversionUrl (constant.ts) use. Fetched once per page load and cached.
import { useEffect, useState } from 'react';
import { getApiCall } from '@/service/httpCall';
import { AGENT_CALL_CONNECT_LIST } from '@/service/url';

let nodeEnvPromise: Promise<string> | null = null;

/** Backend NODE_ENV, lower-cased ('development' | 'staging' | 'production'); '' if unknown. */
export const getNodeEnv = (): Promise<string> => {
  if (!nodeEnvPromise) {
    nodeEnvPromise = (getApiCall(AGENT_CALL_CONNECT_LIST, {}) as Promise<{ node_env?: string } | undefined>)
      .then((resp) => String(resp?.node_env || '').trim().toLowerCase())
      .catch(() => {
        nodeEnvPromise = null; // let a later caller retry
        return '';
      });
  }
  return nodeEnvPromise;
};

/** Backend NODE_ENV for components; null until it has loaded. */
export const useNodeEnv = (): string | null => {
  const [nodeEnv, setNodeEnv] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    void getNodeEnv().then((env) => {
      if (alive) setNodeEnv(env);
    });
    return () => {
      alive = false;
    };
  }, []);
  return nodeEnv;
};
